module.exports = __webpack_public_path__ + "img/tagline.841454eb.png";